import { reactive, readonly } from 'vue'
import Util from '@/utils/util'
import Config from '@/utils/config'

const state = reactive({
  accountInfo: null,
  companyStyle: null,
  enumMap: {},
  enumData: {}
})

export const useGlobalStore = {
  state: readonly(state),

  getToken() {
    return localStorage.getItem(Config.tokenKey) || state.token || ''
  },

  setAccountInfo(info) {
    state.accountInfo = info
    if (info) localStorage.setItem(Config.accountKey, JSON.stringify(info))
  },

  getAccountInfo() {
    if (state.accountInfo) return Promise.resolve(state.accountInfo)
    const cached = Util.getAccountInfo()
    if (cached) {
      state.accountInfo = cached
      return Promise.resolve(cached)
    }
    return Util.ajax({ url: Util.getApiUrl('/main/getAccount') }).then((data) => {
      state.accountInfo = data
      localStorage.setItem(Config.accountKey, JSON.stringify(data))
      return data
    })
  },

  loadCompanyStyle() {
    if (state.companyStyle) return Promise.resolve(state.companyStyle)
    const websiteUrl = location.host.indexOf('.') > 0
      ? location.host.substring(0, location.host.indexOf('.'))
      : ''
    return Util.ajax({
      data: { websiteUrl },
      url: Util.getApiUrl('/main/getCompanyStyle')
    }, null, true).then((data) => {
      state.companyStyle = data || {}
      return state.companyStyle
    })
  },

  loadEnumData() {
    if (Object.keys(state.enumMap).length) return Promise.resolve(state.enumData)
    return Util.ajax({
      method: 'POST',
      data: {},
      url: Util.getApiUrl('/main/getCodeList')
    }).then((data) => {
      const enumData = {}
      const enumMap = {}
      Object.keys(data || {}).forEach((name) => {
        enumData[name] = []
        enumMap[name] = {}
        Object.keys(data[name]).forEach((code) => {
          const item = { code: Number(code), text: data[name][code] }
          enumData[name].push(item)
          enumMap[name][Number(code)] = item
        })
      })
      state.enumData = enumData
      state.enumMap = enumMap
      return enumData
    })
  },

  getUrl(url, defaultUrl = '') {
    return Util.getUrl(url, defaultUrl)
  },

  clear() {
    state.accountInfo = null
    state.companyStyle = null
  }
}
